import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/up.svg'
import _imports_1 from '@/assets/images/down.svg'
import _imports_2 from '@/assets/images/loading_icon.png'
import _imports_3 from '@/assets/images/loading_icon@2x.png'
import _imports_4 from '@/assets/images/nodata.png'
import _imports_5 from '@/assets/images/nodata@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-1e8c76c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_3 + ' 2x'
const _hoisted_2 = _imports_5 + ' 2x'
const _hoisted_3 = { class: "home" }
const _hoisted_4 = {
  class: "top",
  style: {"z-index":"9999"}
}
const _hoisted_5 = {
  class: "triangle",
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  class: "triangle",
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  class: "triangle",
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = {
  class: "triangle",
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "list"
}
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "time" }
const _hoisted_15 = { class: "money" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "兑换金额", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "money" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "兑换结果", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "loading"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  srcset: _hoisted_1
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(255, 255, 255, 0.9)"} }, "加载中", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "nodata"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  srcset: _hoisted_2
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无换汇记录", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDirection = true))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.showDirection ? 'orange' : '')
        }, _toDisplayString(_ctx.currentDirection), 3),
        _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
          [_vShow, _ctx.showDirection]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
          [_vShow, !_ctx.showDirection]
        ])
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showState = true))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.showState ? 'orange' : '')
        }, _toDisplayString(_ctx.currentState), 3),
        _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
          [_vShow, _ctx.showState]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
          [_vShow, !_ctx.showState]
        ])
      ]),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.showDirection,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDirection) = $event)),
        "close-on-click-action": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directionActions, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["content", item.name === _ctx.currentDirection ? 'active' : '']),
              style: {"z-index":"9999"},
              key: item.name,
              onClick: ($event: any) => (_ctx.onDirectionSelect(item))
            }, _toDisplayString(item.name), 11, _hoisted_9))
          }), 128))
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.showState,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showState) = $event)),
        "close-on-click-action": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateActions, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["content", item.name === _ctx.currentState ? 'active' : '']),
              style: {"z-index":"9999"},
              key: item.name,
              onClick: ($event: any) => (_ctx.onStateSelect(item))
            }, _toDisplayString(item.name), 11, _hoisted_10))
          }), 128))
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    (_ctx.total !== 0 && !_ctx.searchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: item.exchangeOri
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.exchangeOri), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_14, "（" + _toDisplayString(item.createTime) + ")", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: `${_ctx.filterColor(item)}` })
                      }, _toDisplayString(item.status), 5)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatNumber(item.exchangeOutMoney)) + _toDisplayString(_ctx.filterMoneyType(item.outCurrencyType).name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatNumber(item.exchangeInMoney)) + _toDisplayString(_ctx.filterMoneyType(item.inCurrencyType).name), 1)
                  ]),
                  _hoisted_21
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.searchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
      : _createCommentVNode("", true),
    (_ctx.total === 0 && !_ctx.searchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
      : _createCommentVNode("", true)
  ]))
}